import React from "react";

import loadIcon from "../../../assets/images/tail-spin.svg";

import ModalHolder from "../../molecules/ModalHolder";

import { H3, P } from "../../atoms/Texts";
import { PrimaryButton } from "../../atoms/Buttons";

const AcceptRejectlModal = ({
  loading,
  closeModal,
  header,
  text,
  body,
  action,
  cta,
  type,
}) => {
  return (
    <ModalHolder closeModal={closeModal}>
      <div className="pb-12">
        <H3 color="#22202D" fontFamily="medium" className="text-center">
          {header}
        </H3>
        <P color="#7D7B96" className="text-center md:w-3/4 mx-auto mt-2 mb-12">
          {text}
        </P>
        <div className="items-center">{body}</div>

        <div className="flex">
          <PrimaryButton.Light
            type="button"
            onClick={closeModal}
            className="w-1/2"
            disabled={loading}
          >
            {!loading ? (
              "Cancel"
            ) : (
              <img src={loadIcon} alt="Loading" className="mx-auto h-6 w-6" />
            )}
          </PrimaryButton.Light>
          <PrimaryButton
            className="w-full ml-10"
            disabled={loading}
            onClick={action}
          >
            {!loading ? (
              cta
            ) : (
              <img src={loadIcon} alt="Loading" className="mx-auto h-6 w-6" />
            )}
          </PrimaryButton>
        </div>
      </div>
    </ModalHolder>
  );
};

export default AcceptRejectlModal;
